import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MessagesFiltersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MessagesFiltersQuery = { __typename?: 'Query', getAllMessagesFilters?: { __typename?: 'EIMMessagesFilters', company?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, process?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, m_interface?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, status?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, step_number?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, step?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, duplicate?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, sys_id?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, group_name?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null, m_format?: Array<{ __typename?: 'GridFilter', text?: string | null, value?: string | null }> | null } | null };

export type Get_InvoicesStatusesQueryVariables = Types.Exact<{
  env: Types.Scalars['String']['input'];
  request: Types.EimMonitoringGridRequest;
}>;


export type Get_InvoicesStatusesQuery = { __typename?: 'Query', getEIMInvoices?: { __typename?: 'EIMMonitoringGridResponse', total?: number | null, invoiceStatusesList?: Array<{ __typename?: 'EIMInvoiceStatus', id?: number | null, message_id?: string | null, partnerno?: string | null, company?: string | null, reference?: string | null, bmw_int_reference?: string | null, duplicate?: number | null, cross_border?: string | null, process?: string | null, m_interface?: string | null, step_number?: number | null, step?: string | null, status?: string | null, status_reason?: string | null, creation_ts?: string | null, sdi_number?: string | null, invoice_date?: string | null, log_obj_id?: number | null, log_status_id?: number | null, edi_agreement_date?: string | null, sys_id?: string | null, ebox_folder?: string | null, m_format?: string | null, vin_number?: string | null, process_code?: string | null, route_id?: string | null, group_name?: string | null, log_info_id?: number | null, incident_no?: string | null, ext_reference?: string | null, channel?: string | null, target_directory?: string | null, insert_user?: string | null, update_user?: string | null, insert_ts?: string | null, original_log_obj_id?: number | null, system_id?: number | null, partner_country?: string | null, partner_name?: string | null, document_available?: boolean | null, uuid?: string | null, file_name?: string | null, id_partner?: number | null, clearing_house?: string | null, shippartnerno?: string | null, edp_relevant?: boolean | null, updatetime?: string | null, m_process?: string | null, final_completion?: string | null, c_status?: string | null, m_provider?: string | null, received_date?: string | null, complete_date?: string | null, m_invprocess?: string | null, md_process_id?: number | null, process_error?: string | null, apar?: string | null, document_type?: string | null, gross_amount?: number | null, tax_amount?: number | null, currency?: string | null }> | null } | null };

export type UpdateInvoiceStatusesMutationVariables = Types.Exact<{
  env: Types.Scalars['String']['input'];
  request: Types.EimStatusUpdateRequest;
}>;


export type UpdateInvoiceStatusesMutation = { __typename?: 'Mutation', updateEIMInvoiceStatuses: { __typename?: 'EIMUpdateResponse', updatedRows: number } };


export const MessagesFiltersDocument = gql`
    query messagesFilters {
  getAllMessagesFilters {
    company {
      text
      value
    }
    process {
      text
      value
    }
    m_interface {
      text
      value
    }
    status {
      text
      value
    }
    step_number {
      text
      value
    }
    step {
      text
      value
    }
    duplicate {
      text
      value
    }
    sys_id {
      text
      value
    }
    group_name {
      text
      value
    }
    m_format {
      text
      value
    }
  }
}
    `;

/**
 * __useMessagesFiltersQuery__
 *
 * To run a query within a React component, call `useMessagesFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessagesFiltersQuery(baseOptions?: Apollo.QueryHookOptions<MessagesFiltersQuery, MessagesFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesFiltersQuery, MessagesFiltersQueryVariables>(MessagesFiltersDocument, options);
      }
export function useMessagesFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesFiltersQuery, MessagesFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesFiltersQuery, MessagesFiltersQueryVariables>(MessagesFiltersDocument, options);
        }
// @ts-ignore
export function useMessagesFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessagesFiltersQuery, MessagesFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<MessagesFiltersQuery, MessagesFiltersQueryVariables>;
export function useMessagesFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessagesFiltersQuery, MessagesFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<MessagesFiltersQuery | undefined, MessagesFiltersQueryVariables>;
export function useMessagesFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessagesFiltersQuery, MessagesFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagesFiltersQuery, MessagesFiltersQueryVariables>(MessagesFiltersDocument, options);
        }
export type MessagesFiltersQueryHookResult = ReturnType<typeof useMessagesFiltersQuery>;
export type MessagesFiltersLazyQueryHookResult = ReturnType<typeof useMessagesFiltersLazyQuery>;
export type MessagesFiltersSuspenseQueryHookResult = ReturnType<typeof useMessagesFiltersSuspenseQuery>;
export type MessagesFiltersQueryResult = Apollo.QueryResult<MessagesFiltersQuery, MessagesFiltersQueryVariables>;
export const Get_InvoicesStatusesDocument = gql`
    query GET_InvoicesStatuses($env: String!, $request: EIMMonitoringGridRequest!) {
  getEIMInvoices(env: $env, request: $request) {
    invoiceStatusesList {
      id
      message_id
      partnerno
      company
      reference
      bmw_int_reference
      duplicate
      cross_border
      process
      m_interface
      step_number
      step
      status
      status_reason
      creation_ts
      sdi_number
      invoice_date
      log_obj_id
      log_status_id
      edi_agreement_date
      sys_id
      ebox_folder
      m_format
      vin_number
      process_code
      route_id
      group_name
      log_info_id
      incident_no
      ext_reference
      channel
      target_directory
      insert_user
      update_user
      insert_ts
      original_log_obj_id
      system_id
      partner_country
      partner_name
      document_available
      uuid
      file_name
      id_partner
      clearing_house
      shippartnerno
      edp_relevant
      updatetime
      m_process
      final_completion
      c_status
      m_provider
      received_date
      complete_date
      m_invprocess
      md_process_id
      process_error
      apar
      document_type
      gross_amount
      tax_amount
      currency
    }
    total
  }
}
    `;

/**
 * __useGet_InvoicesStatusesQuery__
 *
 * To run a query within a React component, call `useGet_InvoicesStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_InvoicesStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_InvoicesStatusesQuery({
 *   variables: {
 *      env: // value for 'env'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGet_InvoicesStatusesQuery(baseOptions: Apollo.QueryHookOptions<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables> & ({ variables: Get_InvoicesStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>(Get_InvoicesStatusesDocument, options);
      }
export function useGet_InvoicesStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>(Get_InvoicesStatusesDocument, options);
        }
// @ts-ignore
export function useGet_InvoicesStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>;
export function useGet_InvoicesStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<Get_InvoicesStatusesQuery | undefined, Get_InvoicesStatusesQueryVariables>;
export function useGet_InvoicesStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>(Get_InvoicesStatusesDocument, options);
        }
export type Get_InvoicesStatusesQueryHookResult = ReturnType<typeof useGet_InvoicesStatusesQuery>;
export type Get_InvoicesStatusesLazyQueryHookResult = ReturnType<typeof useGet_InvoicesStatusesLazyQuery>;
export type Get_InvoicesStatusesSuspenseQueryHookResult = ReturnType<typeof useGet_InvoicesStatusesSuspenseQuery>;
export type Get_InvoicesStatusesQueryResult = Apollo.QueryResult<Get_InvoicesStatusesQuery, Get_InvoicesStatusesQueryVariables>;
export const UpdateInvoiceStatusesDocument = gql`
    mutation UpdateInvoiceStatuses($env: String!, $request: EIMStatusUpdateRequest!) {
  updateEIMInvoiceStatuses(env: $env, request: $request) {
    updatedRows
  }
}
    `;
export type UpdateInvoiceStatusesMutationFn = Apollo.MutationFunction<UpdateInvoiceStatusesMutation, UpdateInvoiceStatusesMutationVariables>;

/**
 * __useUpdateInvoiceStatusesMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceStatusesMutation, { data, loading, error }] = useUpdateInvoiceStatusesMutation({
 *   variables: {
 *      env: // value for 'env'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateInvoiceStatusesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceStatusesMutation, UpdateInvoiceStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceStatusesMutation, UpdateInvoiceStatusesMutationVariables>(UpdateInvoiceStatusesDocument, options);
      }
export type UpdateInvoiceStatusesMutationHookResult = ReturnType<typeof useUpdateInvoiceStatusesMutation>;
export type UpdateInvoiceStatusesMutationResult = Apollo.MutationResult<UpdateInvoiceStatusesMutation>;
export type UpdateInvoiceStatusesMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceStatusesMutation, UpdateInvoiceStatusesMutationVariables>;